module.exports = __webpack_public_path__ + "img/creative-commons-share.2225a1b5.svg";